import {
  Card,
  Col,
  DatePicker,
  Form,
  Radio,
  Row,
  Space,
  Tree,
  Typography
} from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { validateEndDate } from "../dateValidator";
const { Title } = Typography;
const dateFormat = "MM/DD/YYYY";

const Records = ({
  getChildData,
  patientDetailsData,
  form,
  checkedKeys,
  setCheckedKeys,
}) => {
  const [autoExpandParent, setAutoExpandParent] = useState(false);

  const onChange = (e) => {
    let timeFrameVal =
      e.target.value == 1
        ? "Date Range"
        : e.target.value == 2
          ? "Last 2 years"
          : e.target.value == 3
            ? "All time"
            : "";
    debugger;
    callparent(timeFrameVal, "RecordInformationTimeFrame");
  };
  const onExpand = () => {
    // or, you can remove all expanded children keys.
    setAutoExpandParent(false);
  };
  const onCheck = (checkedKeysValue) => {
    var recordType = "";
    checkedKeysValue.forEach((element) => {
      if (recordType == "") recordType = recordType.concat(element);
      else recordType = recordType.concat(", ".concat(element));
    });
    setCheckedKeys(checkedKeysValue);
    callparent(recordType, "RecordInformationRecordType");
    localStorage.setItem("allrecord", JSON.stringify(checkedKeysValue));
    form.validateFields(["tree"]);
  };

  const callparent = (e, name) => {
    getChildData(e, name);
  };
  const disableFutureDates = (current) => {
    // Can not select days after today
    return current && current > dayjs().endOf("day");
  };
  const disablePastDates = (current) => {
    // Can not select days after today
    return patientDetailsData.RecordInformationStartDate && patientDetailsData.RecordInformationStartDate > current;
  };
  const treeData = [
    {
      title: "All Records",
      key: "allrecords",
      className: "all-check",
      children: [
        {
          className: "checkbox-align-width",
          title: "Medical (all)",
          key: "medicalall",
          children: [
            {
              title: "Cardiology Reports",
              key: "Cardiology Report",
            },
            {
              title: "Consultation Reports",
              key: "Consultation Reports",
            },
            {
              title: "Continuity Care Document",
              key: "Continuity Care Document",
            },
            {
              title: "Discharge Summary",
              key: "Discharge Summary",
            },
            {
              title: "Genetic Test Results",
              key: "Genetic Test Results",
            },
            {
              title: "History and Physical",
              key: "History and Physical",
            },
            {
              title: "Hospital/ER Visits",
              key: "Hospital/ER Visits",
            },
            {
              title: "Lab Reports",
              key: "Lab Reports",
            },
            {
              title: "Medications",
              key: "Medications",
            },
            {
              title: "Operative Reports",
              key: "Operative Reports",
            },
            {
              title: "Pathology Reports",
              key: "Pathology Reports",
            },
            {
              title: "Progress Notes",
              key: "Progress Notes",
            },
            {
              title: "Radiology Reports",
              key: "Radiology Reports",
            },
            {
              title: "Therapy Notes",
              key: "Therapy Notes",
            },
            {
              title: "Vaccinations",
              key: "Vaccinations",
            },
          ],
        },
        {
          className: "checkbox-align-width",
          title: "Billing",
          key: "Billing",
        },
        {
          className: "checkbox-align-width",
          title: "Radiology Images",
          key: "Radiology images",
        },
        {
          className: "checkbox-align-width",
          title: "X-ray Images",
          key: "X-ray Images",
        },
        {
          className: "checkbox-align-width",
          title: "CT Scan Images",
          key: "CT Scan Images",
        },
      ],
    },
  ];

  useEffect(() => {
    form.validateFields(["Tree"]);
  }, [checkedKeys, form]);

  const onTitleClick = (e, node) => {
    e.stopPropagation(); // Prevent event bubbling
    const nodeKey = node.key;
    const isChecked = checkedKeys.includes(nodeKey);
    const newCheckedKeys = isChecked
      ? checkedKeys.filter((key) => key !== nodeKey) // Uncheck if already checked
      : [...checkedKeys, nodeKey]; // Check if not already checked

    setCheckedKeys(newCheckedKeys);
  };
  const validateTree = (checkedKeys) => {
    return checkedKeys.length > 0;
  };

  return (
    <>
      <Card
        styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
        bordered={false}
        size="0"
        title={
          <Title
            className="font-semibold"
            style={{ marginBottom: "0" }}
            level={4}
          >
            Record Information
          </Title>
        }
      >
        <Row gutter={[0, 10]} className="px-1 lg:px-6" align={"bottom"} >
          <Col>
            <Form.Item
              name="timeframerecords"
              label="Specify the timeframe for the records"
              required
              rules={[{ required: true, message: "Please choose any option." }]}
            >
              <Radio.Group onChange={onChange} >
                <Space direction="vertical" className="ms-4"
                >
                  <Radio value={3} className="font-normal">
                    All time
                  </Radio>
                  <Radio value={2} className="font-normal">
                    Last 2 years
                  </Radio>
                  <Radio value={1} className="font-normal">
                    Date Range
                  </Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
          {patientDetailsData.RecordInformationTimeFrame.toString() ==
            "Date Range" ? (
            <Col lg={12}>
              <Row gutter={[20, 0]} justify={"start"}>
                <Col span={12} >
                  <Form.Item
                    labelCol={{ xl: 9 }}
                    justify="start"
                    layout="horizontal"
                    name="startdate"
                    label="Start Date"
                    required
                    rules={[
                      { required: true, message: "Please select the start date." },
                    ]}
                  >
                    <DatePicker
                      disabledDate={disableFutureDates}
                      format={dateFormat}
                      style={{ minWidth: "100%" }}
                      onChange={(e) =>
                        callparent(e, "RecordInformationStartDate")
                      }

                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    labelCol={{ xl: 9 }}
                    layout="horizontal"
                    wrapperCol={{
                      xl: 24
                    }}
                    label="End Date"
                    name="enddate"
                    required
                    rules={[
                      { required: true, message: "Please select the end date." },
                      { validator: () => validateEndDate(patientDetailsData.RecordInformationStartDate, patientDetailsData.RecordInformationEndDate) }
                    ]}
                  >
                    <DatePicker
                      disabledDate={disableFutureDates}
                      format={dateFormat}
                      style={{ minWidth: "100%" }}
                      onChange={(e) => callparent(e, "RecordInformationEndDate")}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          ) : null}
        </Row>

        <Row gutter={[0, 10]} className="px-6">

          <Col span={24}>
            <Form.Item
              name="selectrecord"
              required
              rules={[
                {
                  required: checkedKeys.length == 0 ? true : false,
                  message: "Please select at least one node.",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="What type of records are you requesting?"
            >
              <Tree
                className="px-5 tree-responsive"
                checkable
                onExpand={onExpand}
                autoExpandParent={autoExpandParent}
                onCheck={onCheck}
                checkedKeys={checkedKeys}
                treeData={treeData}
                defaultExpandedKeys={["medicalall", "allrecord", "discimages"]}
                titleRender={(node) => (
                  <div onClick={(e) => onTitleClick(e, node)}>{node.title}</div>
                )}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </>
  );
};
export default Records;
